import type { ComponentProps } from 'react';

import createModalsContext from '~/domains/common/context/createModalsContext';
import type TooManyAttemptsModal from '~/domains/auth/components/TooManyAttemptsModal/TooManyAttemptsModal';
import type ExistingAccountModal from '~/domains/auth/components/ExistingAccountModal/ExistingAccountModal';

type TooManyAttemptsModalType = {
  type: 'TooManyAttemptsModal';
} & Omit<ComponentProps<typeof TooManyAttemptsModal>, 'isOpen'>;

type ExistingAccountModalType = {
  type: 'ExistingAccountModal';
} & Omit<ComponentProps<typeof ExistingAccountModal>, 'isOpen'>;

type AuthModalType = TooManyAttemptsModalType | ExistingAccountModalType;

const { ModalsContext, ModalsContextProvider } = createModalsContext<AuthModalType>();

export { ModalsContext as AuthModalsContext, ModalsContextProvider as AuthModalsContextProvider };
